import "./style.scss";


function Button({ children, onClick, href, target }) {

  if (href) {
    return <a className="dsearch-button" href={href} target={target}>
      {children}
    </a>
  }

  return (
    <div className="dsearch-button" onClick={onClick}>
      {children}
    </div>
  );
}

export default Button;
